import { CreateDepositRequestDto } from '@starsoft/common/dto';
import { DetailedDeposit } from '@starsoft/common/models/deposit/detailed';
import { AxiosInstance, AxiosResponse } from 'axios';

export async function createDeposit(
  data: CreateDepositRequestDto,
  axiosInstance: AxiosInstance,
): Promise<DetailedDeposit> {
  const response: AxiosResponse<DetailedDeposit> =
    await axiosInstance.post<DetailedDeposit>('/deposits', data, {
      timeout: 30 * 1000,
    });

  return response.data;
}
